import { Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rc-cancel-edit-modal',
  templateUrl: './cancel-edit-modal.component.html',
  imports: [ModalModule, TranslatePipe, TranslateDirective, ButtonV2Module],
})
export class CancelEditModalComponent {
  private readonly modalRef = inject<ModalRef<void, null>>(ModalRef);

  abort() {
    this.modalRef.close();
  }

  ok() {
    this.modalRef.emitAndClose(null);
  }
}
